import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_PROFILE_DATA_REQUEST } from '../constants';
import { fetchProfileDataSuccess, fetchProfileDataFailure } from '../actions/profileAction';
import { clientAPI } from '../../utils/axiosInstance';

function* profileSaga(action) {
  try {
    const { studentId } = action.payload;
    const response = yield call([clientAPI,'get'], `/student/${studentId}`);
    yield put(fetchProfileDataSuccess(response.data));
  } catch (error) {
    console.log("Error from profile saga", error);
    yield put(fetchProfileDataFailure(error.response?.data?.errorMessage || 'Login Failed, Try Again'));
  }
}

export default function* watchProfile() {
  yield takeLatest(FETCH_PROFILE_DATA_REQUEST, profileSaga);
}